import { useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../lib/AuthContext';
import { useI18n } from '../lib/i18n';

export default function VerifyEmailPage() {
  const { user, signOut } = useAuth();
  const { t } = useI18n();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const resend = async () => {
    setSending(true);
    try {
      await supabase.auth.resend({ type: 'signup', email: user?.email });
      setSent(true);
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logoBadge}>FA</div>
        <h1 style={styles.heading}>{t('thanksForSigningUp')}</h1>
        <p style={styles.body}>
          {t('verifyEmailBodyPrefix')} <strong>{user?.email}</strong>.
        </p>

        {sent && (
          <div style={styles.successBox}>
            {t('newVerificationLinkSent')}
          </div>
        )}

        <button onClick={resend} disabled={sending} style={styles.primaryBtn}>
          {sending ? t('sendingEllipsis') : t('resendVerificationBtn')}
        </button>

        <button onClick={signOut} style={styles.logoutLink}>{t('logOutLink')}</button>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh', background: 'var(--paper)', display: 'flex',
    alignItems: 'center', justifyContent: 'center', padding: 24,
  },
  card: {
    background: 'var(--surface)', borderRadius: 10, padding: '40px 32px',
    maxWidth: 440, width: '100%', textAlign: 'center', boxShadow: 'var(--shadow-md)',
  },
  logoBadge: {
    width: 56, height: 56, borderRadius: 10, background: 'var(--teal-800)',
    color: 'var(--lavender-300)', display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 16, margin: '0 auto 20px',
  },
  heading: { fontSize: 24, marginBottom: 14 },
  body: { fontSize: 15, color: 'var(--ink-700)', lineHeight: 1.6, marginBottom: 24 },
  successBox: {
    background: 'var(--forest-100)', color: 'var(--forest-600)', borderRadius: 10,
    padding: '10px 14px', fontSize: 13, marginBottom: 20,
  },
  primaryBtn: {
    width: '100%', background: 'var(--teal-800)', color: '#fff', border: 'none',
    borderRadius: 8, padding: '14px 0', fontWeight: 700, fontSize: 15, marginBottom: 16,
  },
  logoutLink: { border: 'none', background: 'none', color: 'var(--ink-500)', fontSize: 14, textDecoration: 'underline' },
};
